<template>
  <div class="page-follow-up-detail">
    <div class="content">
      <section class="top">
        <template v-if="planExecuted">
          <b class="title"
            >{{ data.healthPlanInfo.patientName }}的{{
              data.healthPlanInfo.planName
            }}
          </b>
          <van-progress  color="linear-gradient(to right, #67CDFE, #1E8DFF)" stroke-width="6" :percentage="percent" />
          <span class="progress">
            已完成{{data.healthPlanInfo.followUpDayFinishedCount}}/{{data.healthPlanInfo.followUpDayTotalCount}}
          </span>
          <van-image
            v-if="data.healthPlanInfo.patientPlanStatus === 'FINISHED'"
            width="60"
            height="60"
            fit="cover"
            :src="require('@/assets/imgs/plan-finished.png')"
            style="position: absolute; bottom:0;right:0;"
          />
        </template>
        <template v-else>
          <b class="title"
            >{{ data.healthPlanInfo.patientName }}你好，{{ data.healthPlanInfo.doctorName }}医生免费为您制定了{{
              data.healthPlanInfo.planName
            }}
          </b>
          <div class="flex space-between left">
            <van-image
              round
              width="48"
              height="48"
              fit="cover"
              class="flex no-shrink"
              :src="data.healthPlanInfo.doctorAvatar || require('@/assets/imgs/default-speicalist-avatar.png')"
            />
            <div class="right">
              <b class="doctor">{{ data.healthPlanInfo.doctorName }} {{ data.healthPlanInfo.doctorTitle }}</b>
              <p class="desc">
                {{ data.healthPlanInfo.planInvitationText }}
              </p>
            </div>
          </div>
        </template>
        
      </section>

      <section class="plan" v-if="!planExecuted">
        <div class="flex align-center">计划预览</div>
        <p>{{ data.healthPlanInfo.cycleDays }}天计划周期 {{ data.healthPlanInfo.followUpDayTotalCount }}次病情关怀</p>
      </section>

      <section>
        <!-- <span class="medicine" v-if="!planExecuted">GnRH-a注射</span> -->
        <span class="medicine" v-if="!planExecuted">{{data.healthPlanInfo.planBaseTimeDesc}}</span>
        <van-tabs border class="tabs" v-model="active" title-active-color="#1E8DFF">
          <div class="doctor-info">
            <div class="doctor-info-left">
              <van-image
                round
                width="48"
                height="48"
                fit="cover"
                class="flex no-shrink"
                :src="data.healthPlanInfo.doctorAvatar || require('@/assets/imgs/default-speicalist-avatar.png')"
              />
              <span class="doctor-title">
                {{data.healthPlanInfo.doctorName}} {{data.healthPlanInfo.doctorTitle}}
              </span>
            </div>
            <van-button size="small" @click="handleViewDoctor">联系医生</van-button>
          </div>
          <van-tab :dot="item.status === 1" v-for="(item, index) in data.healthPlanPointList" :key="index">
            <div slot="title" :class="{execting: item.isShowPoint}">
              {{item.title}}
            </div>
            <template v-if="planExecuted">
              <div v-for="(task, index2) in item.itemList" :key="index2">
                <div v-if="task.type == 1" class="doctor-advice">
                  <div style="display: flex; justify-content: space-between;">
                    <h5>
                      医生叮嘱
                    </h5>
                    <span>
                      {{ taskStatusLabel[task.taskStatus] }}
                    </span>
                  </div>
                  <span style="color: #333;">
                    {{task.taskContent}}
                  </span>
                </div>
                <div v-if="task.type == 3" class="patient-review">
                  <div style="display: flex; justify-content: space-between;">
                    <h5>
                      完成健康反馈
                    </h5>
                    <span>
                      {{ taskStatusLabel[task.taskStatus] }}
                    </span>
                  </div>
                  <span v-if="task.taskStatus === 0" style="color: #333;font-weight: 600;">
                    {{task.docReplay}}
                  </span>
                  <div v-else>
                    <div class="flex align-center sub-title">
                      <van-image
                        round
                        width="24"
                        height="24"
                        fit="cover"
                        :src="require('@/assets/imgs/default-speicalist-avatar.png')"
                      />&nbsp;&nbsp;医生留言
                    </div>
                    <span>{{task.taskContent}}</span>
                    <div class="flex align-center sub-title">
                      <van-image
                        round
                        width="24"
                        height="24"
                        fit="cover"
                        :src="require('@/assets/imgs/default-speicalist-avatar.png')"
                      />&nbsp;&nbsp;健康反馈
                    </div>
                    <span class="feedback-card" v-if="task.taskStatus === 1">
                      <span>
                        {{task.docReplay}}
                      </span>
                      <span class="btn-feedback" @click="handleFeedBack(task.taskCode)">
                        填写反馈
                      </span>
                    </span>
                    <div v-else-if="task.taskStatus === 2" class="review-card">
                      <span class="review-date">{{task.docReplayDate}}</span>
                      <div class="review-content">
                        <span>
                          {{task.docReplay}}
                        </span>
                        <span class="btn-view" @click="handleViewReply(task.taskCode)">查看</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div v-for="(task, index2) in item.itemList" :key="index2">
                <div v-if="task.type == 1" class="doctor-advice">
                  <div class="flex align-center title">
                    <van-image
                      round
                      width="24"
                      height="24"
                      fit="cover"
                      :src="require('@/assets/imgs/default-speicalist-avatar.png')"
                    />&nbsp;&nbsp;医生叮嘱
                  </div>
                  <b>医生做的</b>
                  <p>对目前的康复阶段给予建议</p>
                  <b>您要配合的</b>
                  <p>查看医生的留言，并按要求反馈病情</p>
                </div>

                <div v-if="task.type == 3" class="patient-review">
                  <div class="flex align-center title">
                    <van-image
                      round
                      width="24"
                      height="24"
                      fit="cover"
                      :src="require('@/assets/imgs/default-speicalist-avatar.png')"
                    />&nbsp;&nbsp;患者反馈
                  </div>
                  <b>医生做的</b>
                  <p>完成问诊，告知健康管理的重要事项</p>
                  <b>您要配合的</b>
                  <p>查看问诊提醒，并按要求完成健康反馈</p>
                </div>
              </div>
            </template>
          </van-tab>
        </van-tabs>
      </section>
    </div>
    <div class="bottom-btn">
      <template v-if="data.healthPlanInfo.patientPlanStatus === 'WAIT_ACCEPT'">
        <van-button type="primary" block @click="openPlan">免费开启健康计划</van-button>
        <span class="note flex align-center">还剩{{data.healthPlanInfo.acceptExpireDays}}天有效期</span>
      </template>
      <van-button v-else-if="data.healthPlanInfo.patientPlanStatus === 'EXPIRED'" block plain color="#BFBFBF" class="custom">计划已过期</van-button>
      <van-button v-else-if="data.healthPlanInfo.patientPlanStatus === 'FINISHED'" block plain color="#BFBFBF" class="custom">计划已结束</van-button>
      <p v-else-if="data.healthPlanInfo.patientPlanStatus === 'EXECUTING'"></p>
      <van-button v-else block plain color="#BFBFBF" class="custom">已申请加入，等待医生审核</van-button>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { Progress } from '@zyf2e/capui-mobile';
Vue.use(Progress);

export default {
  data() {
    return {
      key: 'value',
      active: 0,
      data: {
        healthPlanInfo: {},
        healthPlanPointList: [],
      },
      taskStatusLabel: {
        0: '待开启',
        1: '待完成',
        2: '已完成',
        3: '已过期',
      }
    };
  },
  computed: {
    planExecuted() {
      const status = this.data.healthPlanInfo.patientPlanStatus;
      return status === 'EXECUTING' || status === 'FINISHED';
    },
    percent() {
      const { followUpDayFinishedCount, followUpDayTotalCount } = this.data.healthPlanInfo;
      return followUpDayTotalCount === 0 ? '0' : (followUpDayFinishedCount / followUpDayTotalCount * 100).toFixed(0);
    }
  },
  async created() {
    this.init();
  },
  methods: {
    async init() {
      this.data = await this.$fetch.fetchGetApiPatientHealthHealthPlanDetail({ planCode: this.$route.params.id });
      let active = 0;
      this.data.healthPlanPointList.some((v, i) => {
        if (v.isLatest) {
          active = i;
          return true;
        } else {
          return false;
        }
      })
      console.log(this.data)
      this.active = active;
      if (this.$route.query.auto && this.data?.healthPlanInfo?.patientPlanStatus === 'WAIT_ACCEPT') {
        this.openPlan();
      }
    },
    async openPlan() {
      try {
        const { isAuth, message } = await this.$fetch.fetchGetApiPatientHealthHealthAcceptPlan({ planCode: this.$route.params.id });
        if (isAuth == false) {
          this.$router.push({
            name: 'BindingInfo',
            query: { jumpUrl: location.href + '?auto=1', name: '' }
          });
        } else {
          if (message) {
            this.$toast(message);
            setTimeout(() => {
              this.init();
            }, 1000);
          } else {
            this.init();
          }
        }
      } catch (error) {
        //
      }
    },
    handleViewReply(taskCode) {
      this.$router.push(`/questionnaire/answer?code=${taskCode}`)
    },
    handleViewDoctor() {
      this.$router.push({
        name: 'DoctorDetail',
        params: {
          id: this.data.healthPlanInfo.doctorId
        }
      });
    },
    handleFeedBack(taskCode) {
      this.$router.push(`/questionnaire?code=${taskCode}`)
    }
  },
};
</script>
<style lang="less" scoped>
.page-follow-up-detail {
  height: 100vh;
  display: flex;
  flex-direction: column;
  .content {
    flex: 1 1 auto;
    overflow: auto;
  }
  img {
    width: 100px;
  }
  .top {
    position: relative;
  }
  .top,
  .plan {
    background: #fff;
    padding: 12px 16px;
    margin-top: 8px;
  }
  .top .title {
    word-break: break-all;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    width: 100%;

    height: 54px;
    font-size: 18px;

    color: #262626;
    line-height: 27px;
    margin-bottom: 12px;
  }
  .progress {
    display: block;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #A6A8B3;
    margin-top: 8px;
  }
  .right {
    flex: 1 1 auto;
    margin-left: 12px;
  }
  .doctor {
    display: block;
    height: 16px;
    font-size: 16px;
    color: #262626;
    line-height: 16px;
    margin-bottom: 10px;
  }
  .desc {
    // width: 287px;
    padding: 8px;
    background: #e6f7ff;
    border-radius: 0px 8px 8px 8px;

    font-size: 14px;
    font-weight: 400;
    color: #262626;
    line-height: 21px;
  }

  .plan {
    div {
      height: 16px;
      font-size: 16px;
      font-weight: 400;
      color: #262626;
      line-height: 16px;
      margin-bottom: 8px;
      &::before {
        display: inline-block;
        width: 2px;
        height: 12px;
        background: #1e8dff;
        margin-right: 8px;
        color: #ff4d4f;
        font-size: 14px;
        line-height: 1;
        content: '';
      }
    }
    p {
      height: 21px;
      font-size: 14px;
      font-weight: 400;
      color: #8c8c8c;
      line-height: 21px;
    }
  }

  .medicine {
    display: block;
    margin: 15px 15px 0;
  }
  .tabs {
    margin-top: 8px;
    /deep/ .van-info--dot {
      width: 14px;
      height: 14px;
      right: -2px;
      background: url('~@/assets/imgs/gou.png');
      background-size: contain;
      background-repeat: no-repeat;
    }
    .execting {
      &::before {
        content: "·";
        display: inline-block;
        position: absolute;
        transform: translateX(-10px) scale(2);
      }
    }
  }
  .doctor-info {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    background: #fff;
    padding: 8px 16px 13px 12px;
    .doctor-info-left {
      flex: 1 1 auto;
      display: flex;
      align-items: center;
      margin-right: 8px;
      .van-image {
        margin-right: 12px;
      }
      .doctor-title {
        font-size: 16px;
        font-weight: 600;
        color: #262626;
        line-height: 18px;
      }
    }
    .van-button {
      // position: absolute;
      // right: 16px;
      // top: 20px;
      flex: 0 0 auto;
      border: none;
      background: #E6F7FF;
    }
  }
  .doctor-advice,
  .doctor-review, .patient-review {
    background: #fff;
    border-radius: 8px;
    margin: 8px 12px;
    padding: 12px 12px 16px;
    .title {
      margin-bottom: 4px;

      font-size: 14px;
      font-weight: 400;
      color: #8c8c8c;
      line-height: 14px;
    }
    b {
      display: block;
      height: 24px;
      font-size: 16px;
      color: #333333;
      line-height: 24px;
      margin: 8px 0 4px;
    }
    p {
      height: 21px;
      font-size: 14px;
      font-weight: 400;
      color: #8c8c8c;
      line-height: 21px;
    }
    h5 {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #8C8C8C;
      line-height: 14px;
      margin:  5px 0 17px;
    }
    .sub-title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 16px;
      margin: 8px 0 12px;
    }
    span {
      display: block;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #8C8C8C;
      line-height: 21px;
    }
    .review-card {
      .review-date {
        background: #F7F8FA;
        padding: 6px 8px;
      }
      .review-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #E6F7FF;
        height: 32px;
        padding: 0 8px;
        span {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 14px;
        }
        .btn-view {
          color: #1E8DFF;
        }
      }
    }
    .feedback-card {
      display: flex;
      justify-content: space-between;
      .btn-feedback {
        color: #1E8DFF;
      }
    }
  }

  .bottom-btn {
    flex: 0 0 auto;
    margin: 16px;
    position: relative;
    .note {
      position: absolute;
      top: -3px;
      right: 30px;
      height: 14px;
      background: #fa4b4b;
      border-radius: 8px 8px 8px 1px;
      border: 1px solid #ffffff;
      font-size: 10px;
      font-weight: 500;
      color: #ffffff;
      padding: 0 4px;
    }

    .custom {
      border-color: #d9d9d9 !important;
    }
  }
}

.pop-title {
  margin-left: 16px;
  height: 48px;
  font-size: 16px;
  font-weight: 400;
  color: #262626;
  line-height: 48px;
}
</style>
